"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.translateOptionLabel = exports.browserLanguage = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _reactI18next = require("react-i18next");

var _ramda = require("ramda");

var _translations = require("../constants/translations");

var browserLanguage = (typeof window !== 'undefined' && window.navigator ? window.navigator.language || window.navigator.systemLanguage || window.navigator.userLanguage : 'ru').substr(0, 2).toLowerCase();
exports.browserLanguage = browserLanguage;

_i18next["default"].use(_reactI18next.initReactI18next).init({
  resources: _translations.TRANSLATIONS,
  fallbackLng: 'ru',
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  },
  lng: 'ru',
  whitelist: ['ru', 'en', 'ua', 'et', 'lt', 'lv', 'kz', 'th', 'uz']
});

var translateOptionLabel = function translateOptionLabel(option, language) {
  return ((0, _ramda.path)(['translations', 'value'], option) || (0, _ramda.path)(['translations', 'name'], option) ? (0, _ramda.path)(['translations', 'value', language], option) || (0, _ramda.path)(['translations', 'name', language], option) : (0, _ramda.path)(['translations', language], option)) || option.label;
};

exports.translateOptionLabel = translateOptionLabel;
var _default = _i18next["default"];
exports["default"] = _default;